import moment from 'moment'
import * as dateLocale from 'date-fns/locale'
import React from 'react'
import {makeStyles} from 'external/material'
import ReactDatePicker from "react-datepicker"
import {faCalendarAlt} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import "react-datepicker/dist/react-datepicker.css"

const useStyles = makeStyles(datePickerStyles)

export default function DatePicker ({date, minDate, maxDate, onChange, context, popperProps}) {
  
  const classes = useStyles()
  return (
    <ReactDatePicker className={classes.datePicker}
        customInput={<DateInput />}
        PopperProps={popperProps}
        locale={context.languageId == 'en' ? dateLocale.enUS : dateLocale.es}
        selected={moment(date).toDate()}
        minDate={minDate}
        maxDate={maxDate}
        showTimeInput
        dateFormat="MM/dd/yyyy h:mm aa"
        onChange={onChange}
        popperPlacement="top"
        popperModifiers={{
          preventOverflow: {
            enabled: true,
            escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
            boundariesElement: 'viewport'
          }
        }}

    />
    )
}

class DateInput extends React.Component {
    render () {
        return (
        <div className="date-input" onClick={this.props.onClick}>
            <FontAwesomeIcon icon={faCalendarAlt} />
            {this.props.value}
        </div>
        )
    }
}

function datePickerStyles() {
    return {
    datePicker: {
      marginTop: 10,
      marginRight: 20,
      "& .date-input": {
        border: 'solid 1px #4F576E',
        borderRadius: 2,
        padding: 5
      },
      "& svg": {
        marginRight: 5
      }
    }
  }
}

